import { useTranslation } from 'react-i18next';
import { Button } from '../../ui/Button/index.js';

export interface ErrorStateProps {
  /** カスタムタイトル（省略時はi18nから取得） */
  title?: string;
  /** カスタムメッセージ（省略時はi18nから取得） */
  message?: string;
  /** 再試行ボタンのコールバック */
  onRetry?: () => void;
}

/**
 * @graph-stack cortex-admin
 * @graph-domain Engineering
 * @graph-business エラー状態表示。エラーアイコン・タイトル・メッセージ・リトライボタンを表示し、i18nデフォルトメッセージに対応
 * @graph-connects none
 */
export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  const { t } = useTranslation();

  // デフォルト値はi18nから取得
  const displayTitle = title ?? t('common.error');
  const displayMessage = message ?? t('common.error');

  return (
    <div className="flex flex-col items-center gap-4 animate-fade-in">
      <div className="w-12 h-12 rounded-full bg-[var(--color-error-muted)] flex items-center justify-center">
        <svg
          className="w-6 h-6 text-[var(--color-error)]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <div className="text-center">
        <h3 className="text-lg font-semibold text-[var(--color-text-primary)]">{displayTitle}</h3>
        <p className="mt-1 text-sm text-[var(--color-text-secondary)]">{displayMessage}</p>
      </div>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
